import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import { setPortal } from 'modules/portal';
import {
  getRequestList,
  getCardInfo,
  cardDuplicate,
  cardAdd,
  cardModify,
  cardDelete,
  cardList,
  cardTransfer,
  getRankData,
  getScriptUserInfo,
  sendScriptNotification,
} from 'lib/api/script';
import { paramConverter, Validator } from 'modules/common';
import { makeHeadData, makeRowColumn } from 'lib/commonLib';
import { tableHeaders } from 'lib/api/common';

import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import FunctionWrap from 'components/molecules/FunctionWrap';
import NewTableContainer from 'components/molecules/NewTable';

import ScriptModal from './ScriptModal';

const useStyles = makeStyles((theme) => ({
  box: { padding: 5, borderRadius: 4, color: '#fff' },
}));

const RequestList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({ portal: portal }));
  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const { t } = useTranslation();
  const { solution, handleClickSnackbar, handleLoading } = props;
  const initModal = {
    open: false,
    initParams: {},
    params: {},
    headerTitle: t('카드 등록'),
    confirmBtnTitle: t('등록'),
  };
  const initError = {
    state: false,
    title: false,
    solution: false,
    manager: false,
  };
  const [duplicate, setDuplicate] = useState(false);
  const [modal, setModal] = useState(initModal);
  const [error, setError] = useState(initError);
  const [pageLoading, setPageLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [rankCustom, setRankCustom] = useState({});
  const [pageType, setPageType] = useState('add');
  const [userList, setUserList] = useState([]);
  const [rankData, setRankData] = useState([]);
  const [rankHead, setRankHead] = useState([]);
  const [rankLoading, setRankLoading] = useState(false);
  const [requestData, setRequestData] = useState([]);
  const [requestLoading, setRequestLoading] = useState(true);
  const [cardData, setCardData] = useState([]);
  const [cardHead, setCardHead] = useState([]);
  const [cardLoading, setCardLoading] = useState(true);
  // const [copyText, setCopyText] = useState();
  const [params, setParams] = useState({
    order: 'SCRIPT_CREATE_DATE',
    sort: 'desc',
  });

  const requestHead = [
    {
      'id': 'SCRIPT_CARD_ID',
      'label': 'SCRIPT_CARD_ID',
      'orderFlag': null,
      'type': null,
      'format': null,
      'displayFlag': true,
      'calFlag': false,
    },
    {
      'id': 'SCRIPT_TITLE',
      'label': '카드 제목',
      'orderFlag': true,
      'type': 'string',
      'format': '@',
      'displayFlag': true,
      'calFlag': false,
    },
    {
      'id': 'SCRIPT_URL',
      'label': 'SCRIPT_URL',
      'orderFlag': null,
      'type': null,
      'format': null,
      'displayFlag': true,
      'calFlag': false,
    },
    {
      'id': 'SCRIPT_CREATE_DATE',
      'label': '생성일',
      'orderFlag': true,
      'type': 'date',
      'format': 'yyyy-mm-dd',
      'displayFlag': true,
      'calFlag': false,
    },
  ];

  useEffect(() => {
    handleGetUser();
    handleGetTableHead();
    handleGetData();
    // delayCard();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const newLoading =
      pageLoading || rankLoading || requestLoading || cardLoading;
    if (newLoading === false) handleLoading(newLoading);
    // eslint-disable-next-line
  }, [pageLoading, rankLoading, requestLoading, cardLoading]);

  const handleGetData = () => {
    handleLoading(true);
    setCardLoading(true);
    setRequestLoading(true);
    setRankLoading(true);
    getRankData({
      params: {
        allDay: '01',
        excluded: [
          'khchoi',
          'song2064',
          'dmsdud2356',
          'jundangee',
          'hibolk',
          'admin',
          'enp_wjlee2',
          'sylee2',
          'enp_hilee',
          'sghong',
          'insite',
          'platform',
          'swpark',
          'ykkim',
        ],
        uri: '/script/rank',
      },
    })
      .then((response) => {
        setRankData(response.data.data);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error.message,
          option: { type: 'error' },
        });
      })
      .finally((f) => {
        setRankLoading(false);
        getRequestList({
          params: { order: 'SCRIPT_CREATE_DATE', sort: 'asc' },
        })
          .then((response) => {
            setRequestData(response.data.data);
          })
          .catch((error) => {
            handleClickSnackbar({
              message: error.message,
              option: { type: 'error' },
            });
          })
          .finally((f) => {
            setRequestLoading(false);
            cardList({
              params: {
                order: 'SCRIPT_CREATE_DATE',
                sort: 'desc',
                allDay: '01',
                uri: '/script/list',
              },
            })
              .then((response) => {
                setCardData(response.data.data);
              })
              .catch((error) => {
                handleClickSnackbar({
                  message: error.message,
                  option: { type: 'error' },
                });
              })
              .finally((f) => {
                setCardLoading(false);
              });
          });
      });
  };

  const handleAddTrello = (cardId) => {
    handleLoading(true);
    setPageType('add');
    setPageLoading(true);
    let newModal = { ...initModal };
    getCardInfo({ trelloId: cardId })
      .then((response) => {
        const { data } = response.data;
        newModal.params = {
          state: data.state ? '02' : '01',
          adverId: data.adverId,
          solution: data.solution,
          title: data.title,
          trelloLink: data.trelloLink,
          type: !!data.type ? data.type : 'all',
          extraPoints: '',
          trelloId: modal['params']['trelloId'],
          cardId: cardId,
          addType: '02',
        };
        cardDuplicate({ adverId: data.adverId })
          .then((response) => {
            const state = response.data.data;
            if (state) setDuplicate(true);
            else setDuplicate(false);
          })
          .catch((error) => {
            handleClickSnackbar({
              message: error.message,
              option: { type: 'error' },
            });
          })
          .finally(() => {
            newModal = { ...newModal, open: true };
            setModal(newModal);
            setPageLoading(false);
          });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error.message,
          option: { type: 'error' },
        });
      });
  };

  const handleGetUser = () => {
    getScriptUserInfo()
      .then((response) => {
        let newMember = [];
        let newRankHead = [
          {
            'id': 'SCRIPT_AVG',
            'label': 'SCRIPT_AVG',
            'orderFlag': null,
            'type': null,
            'format': null,
            'displayFlag': true,
            'calFlag': false,
          },
        ];
        let result = {
          SCRIPT_AVG: {
            makeBody: (rowObj) => {
              let result = '';
              if (rowObj['SCRIPT_AVG'] !== '개수')
                if (!!rowObj['isAllDay'])
                  result = '전체 평균(' + rowObj['SCRIPT_AVG'] + ')';
                else result = rowObj['SCRIPT_AVG'];
              else result = t('개수');
              return result;
            },
          },
        };
        let newData = response.data.data;

        for (let i = 0; i < newData.length; i++) {
          if (newData[i]['SCRIPT_USER_ID'] === 'sylee2') {
            newData.splice(i, 1);
          }
          if (newData[i]['SCRIPT_USER_ID'] === 'enp_hilee') {
            newData.splice(i, 1);
          }
        }

        for (let data of newData) {
          let upperUserId = 'SCRIPT_' + data['SCRIPT_USER_ID'].toUpperCase();
          newMember.push({
            HIWK_ID: data['SCRIPT_HIWK_ID'],
            USER_NAME: data['SCRIPT_USER_NAME'],
            USER_ID: data['SCRIPT_USER_ID'],
            TRELLO_ID: data['SCRIPT_TRELLO_ID'],
          });
          if (
            data['SCRIPT_USER_ID'] !== 'hibolk' &&
            data['SCRIPT_USER_ID'] !== 'jundangee'
          ) {
            newRankHead.push({
              'id': upperUserId,
              'label': data['SCRIPT_USER_NAME'],
              'orderFlag': null,
              'type': null,
              'format': null,
              'displayFlag': true,
              'calFlag': false,
            });
          }
          const userId = data['SCRIPT_USER_ID'];
          let upperUserId2 = 'SCRIPT_' + userId.toUpperCase();
          result[upperUserId2] = {
            makeHead: (headsMap) => {
              return data['SCRIPT_USER_NAME'];
            },
            makeBody: (rowObj) => {
              let result;
              let lastWorks = [];
              let resultBox = [];
              if (rowObj['SCRIPT_AVG'] === 'LAST TYPE') {
                if (!!rowObj[upperUserId2])
                  lastWorks = rowObj[upperUserId2].split(',');
                let cnt = 0;
                for (let a of lastWorks) {
                  let name = '';
                  for (let value of solution)
                    if (value['CODE_ID'] === a) name = value['CODE_DESC'];
                  cnt++;
                  resultBox.push(
                    <div
                      key={upperUserId2 + '_' + cnt}
                      style={{
                        background:
                          a === '99'
                            ? '#e772e1'
                            : a === '98'
                            ? '#47a2e7'
                            : a === '96'
                            ? '#f2d600'
                            : '#79bd2f',
                        marginBottom: 5,
                      }}
                      className={classes.box}
                    >
                      {name}
                    </div>
                  );
                }
              }
              if (rowObj['SCRIPT_AVG'] === 'LAST TYPE') {
                result = resultBox;
              } else if (
                rowObj['SCRIPT_AVG'] === '개수' ||
                rowObj['SCRIPT_AVG'] === '주간 개수' ||
                rowObj['SCRIPT_AVG'] === '당일 개수' ||
                rowObj[upperUserId2] > rowObj['SCRIPT_AVG'] ||
                !rowObj[upperUserId2]
              ) {
                result = rowObj[upperUserId2];
              } else {
                result = (
                  <div
                    // style={{
                    //   background:
                    //     Number(rowObj[upperUserId2]) === rowObj['SCRIPT_AVG']
                    //       ? '#ff9f1a'
                    //       : '#eb5a46',
                    // }}
                    style={{ color: '#000' }}
                    className={classes.box}
                  >
                    {rowObj[upperUserId2]}
                  </div>
                );
              }
              return result;
            },
          };
          setRankCustom(result);
        }
        newMember.push(
          { USER_ID: 'platform', USER_NAME: '플랫폼팀' },
          { USER_ID: 'insite', USER_NAME: '인사이트팀' },
          { USER_ID: 'enp_wjlee2', USER_NAME: '이원준' },
          { USER_ID: 'khchoi', USER_NAME: '최광훈' },
          { USER_ID: 'song2064', USER_NAME: '송민혁' },
          { USER_ID: 'dmsdud2356', USER_NAME: '백은영' },
          { USER_ID: 'enp_hilee', USER_NAME: '이혜인' }
        );
        setUserList(newMember);
        setRankHead(newRankHead);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error.message,
          option: { type: 'error' },
        });
      });
  };

  const handleGetTableHead = () => {
    tableHeaders({ uri: '/script/list' })
      .then((response) => {
        setCardHead(response.data.data);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error.message,
          option: { type: 'error' },
        });
      })
      .finally((f) => f);
  };

  const customized = {
    list: {
      SCRIPT_SEQ: { merged: true },
      SCRIPT_STATE: {
        makeBody: (rowObj) => {
          return rowObj['SCRIPT_STATE'] === '02' ? (
            <div style={{ background: '#eb5a46' }} className={classes.box}>
              {t('긴급')}
            </div>
          ) : (
            '-'
          );
        },
      },
      SCRIPT_TYPE: {
        makeBody: (rowObj) => {
          const type = rowObj['SCRIPT_TYPE'];
          return type === '01' ? (
            <div style={{ background: '#f2d600' }} className={classes.box}>
              {t('스크립트')}
            </div>
          ) : type === '02' ? (
            <div style={{ background: '#ff9f1a' }} className={classes.box}>
              {t('인사이트')}
            </div>
          ) : type === '03' ? (
            <div
              style={{ background: 'linear-gradient(70deg, #f2d600, #ff9f1a)' }}
              className={classes.box}
            >
              {t('스크립트 + 인사이트')}
            </div>
          ) : (
            '-'
          );
        },
      },
      SCRIPT_TRELLO_LINK: {
        makeBody: (rowObj) => {
          return (
            <TableBtnWrap>
              <NewButton
                name="editCard"
                title={t('수정')}
                iconBtn
                icon="faEdit"
                disableRipple
                onClick={(e) => handleModalOpen(e, 'modify', rowObj)}
              />
              <NewButton
                name="deleteCard"
                title={t('삭제')}
                iconBtn
                icon="faTrashAlt"
                disableRipple
                onClick={(e) => handleModalOpen(e, 'delete', rowObj)}
              />
              {!!rowObj['SCRIPT_TRELLO_LINK'] && (
                <NewButton
                  name="editCard"
                  title={t('카드 링크')}
                  iconBtn
                  icon="faScroll"
                  disableRipple
                  onClick={(e) => handlePortalUrl(rowObj['SCRIPT_TRELLO_LINK'])}
                />
              )}
            </TableBtnWrap>
          );
        },
        bodyStyle: { width: 80 },
      },
      SCRIPT_SOLUTION: {
        makeBody: (rowObj) => {
          let newName = rowObj['SCRIPT_SOLUTION'];
          for (let value of solution) {
            if (value['CODE_ID'] === rowObj['SCRIPT_SOLUTION']) {
              newName = value['CODE_DESC'];
            }
          }
          return rowObj['SCRIPT_SOLUTION'] === '96' ? (
            <div style={{ background: '#f2d600' }} className={classes.box}>
              {newName}
            </div>
          ) : (
            newName
          );
        },
      },
      SCRIPT_MANAGER: {
        makeBody: (rowObj) => {
          let newName = rowObj['SCRIPT_MANAGER'];
          for (let user of userList) {
            if (user['USER_ID'] === rowObj['SCRIPT_MANAGER']) {
              newName = user['USER_NAME'];
              newName = newName + '(' + rowObj['SCRIPT_MANAGER'] + ')';
            }
          }
          return newName;
        },
      },
      SCRIPT_ADVER_ID: {
        makeBody: (rowObj) => {
          let result = rowObj['SCRIPT_ADVER_ID'];
          return !!result ? rowObj['SCRIPT_ADVER_ID'] : '-';
        },
      },
      SCRIPT_CREATE_DATE: {
        makeBody: (rowObj) => {
          let result = rowObj['SCRIPT_CREATE_DATE'];
          return !!result ? rowObj['SCRIPT_CREATE_DATE'] : '-';
        },
      },
      SCRIPT_CREATE_USER: {
        makeBody: (rowObj) => {
          let result = rowObj['SCRIPT_CREATE_USER'];
          return !!result ? rowObj['SCRIPT_CREATE_USER'] : '-';
        },
      },
      SCRIPT_UPDATE_DATE: {
        makeBody: (rowObj) => {
          let result = rowObj['SCRIPT_UPDATE_DATE'];
          return !!result ? rowObj['SCRIPT_UPDATE_DATE'] : '-';
        },
      },
      SCRIPT_UPDATE_USER: {
        makeBody: (rowObj) => {
          let result = rowObj['SCRIPT_UPDATE_USER'];
          return !!result ? rowObj['SCRIPT_UPDATE_USER'] : '-';
        },
      },
    },
    request: {
      SCRIPT_CARD_ID: {
        makeHead: (headsMap) => {
          return t('관리');
        },
        makeBody: (rowObj, headsMap) => {
          return (
            <TableBtnWrap>
              <NewButton
                name="add"
                title={t('등록')}
                iconBtn
                icon="faPlus"
                disableRipple
                onClick={(f) => handleAddTrello(rowObj['SCRIPT_CARD_ID'])}
              />
            </TableBtnWrap>
          );
        },
      },
      SCRIPT_CREATE_DATE: {
        makeBody: (rowObj, headsMap) => {
          return makeRowColumn(
            rowObj['SCRIPT_CREATE_DATE'],
            'date',
            'YYYY-MM-DD HH:mm:ss'
          );
        },
      },
    },
  };

  const handleModalOpen = (e, type, data) => {
    let newModal = { ...initModal };
    let newHeaderTitle = '';
    let newConfirmTitle = '';
    let newParams;

    switch (type) {
      case 'add':
        newHeaderTitle = t('카드 등록');
        break;
      case 'modify':
        newHeaderTitle = t('카드 수정');
        break;
      case 'delete':
        newHeaderTitle = t('카드 삭제');
        break;
      default:
        newHeaderTitle = t('default');
    }
    if (type === 'delete') newConfirmTitle = t('삭제');
    else if (type === 'add') newConfirmTitle = t('등록');
    else if (type === 'modify') newConfirmTitle = t('수정');

    if (type === 'add') {
      newModal = {
        ...newModal,
        open: true,
        headerTitle: newHeaderTitle,
        confirmBtnTitle: newConfirmTitle,
      };
      if (!!data) {
        setModalLoading(true);
        getCardInfo({ trelloId: modal['params']['trelloId'] })
          .then((response) => {
            const { data } = response.data;
            newModal.params = {
              state: data.state ? '02' : '01',
              adverId: data.adverId,
              manager: data.manager,
              solution: data.solution,
              title: data.title,
              trelloLink: data.trelloLink,
              type: data.type,
              extraPoints: '',
              trelloId: modal['params']['trelloId'],
              addType: '01',
            };
            cardDuplicate({ adverId: data.adverId })
              .then((response) => {
                const state = response.data.data;
                if (state) setDuplicate(true);
                else setDuplicate(false);
              })
              .catch((error) => {
                handleClickSnackbar({
                  message: error.message,
                  option: { type: 'error' },
                });
              })
              .finally(() => {
                setModalLoading(false);
                setModal(newModal);
                setPageType(type);
              });
          })
          .catch((error) => {
            handleClickSnackbar({
              message: error.message,
              option: { type: 'error' },
            });
            setModalLoading(false);
          });
      } else {
        newModal.params = {
          state: '01',
          type: 'all',
        };
        setModal(newModal);
      }
    } else if (type === 'modify') {
      newParams = {
        seq: data['SCRIPT_SEQ'],
        state: data['SCRIPT_STATE'],
        adverId: data['SCRIPT_ADVER_ID'],
        manager: data['SCRIPT_MANAGER'],
        solution: data['SCRIPT_SOLUTION'],
        title: data['SCRIPT_TITLE'],
        trelloLink: data['SCRIPT_TRELLO_LINK'],
        type: data['SCRIPT_TYPE'],
        extraPoints: data['SCRIPT_EXTRA_POINTS'],
      };
      newModal = {
        ...newModal,
        initParams: newParams,
        params: newParams,
      };
    } else if (type === 'delete') {
      newModal = { ...newModal, params: { seq: data['SCRIPT_SEQ'] } };
    }

    if (type !== 'add') {
      newModal = {
        ...newModal,
        open: true,
        headerTitle: newHeaderTitle,
        confirmBtnTitle: newConfirmTitle,
      };
      setModal(newModal);
      setPageType(type);
    }
  };

  const handleModalClose = () => {
    setModal({
      ...initModal,
      params: { trelloId: modal.params.trelloId },
    });
  };

  const handleSubmit = () => {
    setModalLoading(true);
    let validator = false;
    if (pageType === 'add' || pageType === 'modify') {
      validator = Validator(paramConverter(modal['params']), error);
    }
    if (pageType === 'add') {
      if (!!validator['state']) {
        setError(validator['validate']);
        handleClickSnackbar({
          message: t('필수값을 입력해주세요.'),
          option: { type: 'error' },
        });
      } else {
        cardAdd(paramConverter(modal['params']))
          .then(() => {
            if (modal['params']['addType'] === '02') {
              cardTransfer({
                cardId: modal['params']['cardId'],
                managerId: modal['params']['manager'],
                trello: modal['params']['trelloLink'],
              })
                .then(() => {
                  handleClickSnackbar({
                    message: '정상적으로 배정되었습니다.',
                    option: { type: 'success' },
                  });
                })
                .catch((error) => {
                  handleClickSnackbar({
                    message: error,
                    option: { type: 'error' },
                  });
                })
                .finally(() => {
                  setModalLoading(false);
                  handleModalClose();
                  handleGetData();
                });
            } else {
              handleClickSnackbar({
                message: '정상적으로 등록되었습니다.',
                option: { type: 'success' },
              });
              setModalLoading(false);
              handleModalClose();
              handleGetData();
            }
          })
          .catch((err) => {
            handleClickSnackbar({
              message: err,
              option: { type: 'error' },
            });
          });
      }
    } else if (pageType === 'modify') {
      if (
        JSON.stringify(modal['params']) !== JSON.stringify(modal['initParams'])
      ) {
        if (!!validator['state']) {
          setError(validator['validate']);
          setModalLoading(false);
          handleClickSnackbar({
            message: t('필수값을 입력해주세요.'),
            option: { type: 'error' },
          });
        } else {
          cardModify(paramConverter(modal['params']))
            .then((res) => {
              handleClickSnackbar({
                message: res.data.message,
                option: { type: 'success' },
              });
            })
            .catch((err) => {
              handleClickSnackbar({
                message: err,
                option: { type: 'error' },
              });
            })
            .finally(() => {
              setModalLoading(false);
              handleModalClose();
            });
        }
      } else {
        handleClickSnackbar({
          message: t('수정된 내용이 없습니다.'),
          option: { type: 'info' },
        });
        setModalLoading(false);
      }
    } else if (pageType === 'delete') {
      cardDelete(modal['params']['seq'])
        .then((res) => {
          handleClickSnackbar({
            message: res.data.message,
            option: { type: 'success' },
          });
        })
        .catch((err) => {
          handleClickSnackbar({
            message: err,
            option: { type: 'error' },
          });
        })
        .finally(() => {
          setModalLoading(false);
          handleModalClose();
        });
    }
  };

  const modalGetParam = (e, type) => {
    const { value, name } = e.target;
    let newModal = { ...modal };
    newModal = {
      ...newModal,
      params: { ...newModal['params'], [name]: value },
    };
    setModal(newModal);
  };

  const getModalParam = (newParams, name) => {
    if (JSON.stringify(modal['params']) !== JSON.stringify(newParams)) {
      let tempParams = { ...newParams };
      if (name === 'solution' && newParams[name] === '96') {
        delete tempParams['trelloLink'];
        delete tempParams['adverId'];
        tempParams['type'] = 'all';
      } else if (name === 'solution' && newParams[name] === '99') {
        tempParams['type'] = 'all';
      }
      setModal({ ...modal, params: tempParams });
    }
  };

  const handleSendMessage = () => {
    handleLoading(true);
    sendScriptNotification()
      .then((response) => {
        handleClickSnackbar({
          message: response.data.message,
          option: { type: 'success' },
        });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: { type: 'error' },
        });
      })
      .finally(() => {
        handleLoading(false);
      });
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // const delayCard = () => {
  //   let newCardInfo = [];
  //
  //   for (let card of cards) {
  //     let newMng = [];
  //
  //     for (let mng of card.idMembers) {
  //       const newName = findUser(mng);
  //       if (!!newName) {
  //         newMng.push(newName);
  //       }
  //     }
  //     newCardInfo.push({
  //       cardName: card.name,
  //       cardUrl: card.shortUrl,
  //       cardMng: newMng.join(','),
  //     });
  //   }
  //   let result = '';
  //   for (let card of newCardInfo) {
  //     const text =
  //       card.cardName + '/br' + card.cardUrl + '/br' + card.cardMng + '/br/br';
  //     result = result + text + '';
  //   }
  //   setCopyText(result);
  // };
  //
  // const findUser = (mng) => {
  //   let newName = '';
  //   if (
  //     mng !== '595d83dde8c0da0b8705c8c5' &&
  //     mng !== '5b31e3d17ff5fa7ea6e75278' &&
  //     mng !== '5e461890a2a17819058716dd' &&
  //     mng !== '5ffbf6f5c0d1d38bb0dd7bdc' &&
  //     mng !== '60518dc5838fdc0bb4ad3239'
  //   ) {
  //     for (let user of userList22) {
  //       if (user.id === mng) {
  //         newName = user.fullName;
  //       }
  //     }
  //   }
  //   return newName;
  // };

  // const handleCopyText = () => {
  //   const copyText = document.getElementById('copyText');
  //   copyText.select();
  //   document.execCommand('copy');
  // };

  return (
    <>
      <FunctionWrap loading={false}>
        <NewButton onClick={(e) => handleModalOpen(e, 'add')}>등록</NewButton>
        <NewButton onClick={() => handleGetData()}>새로고침</NewButton>
        <NewButton onClick={() => handleSendMessage()}>미처리 알림</NewButton>
        {/*<NewButton onClick={() => handleCopyText()}>미처리 리스트</NewButton>*/}
        {/*<input*/}
        {/*  type="text"*/}
        {/*  id="copyText"*/}
        {/*  value={copyText}*/}
        {/*  style={{ position: 'fixed', top: -99, left: -99 }}*/}
        {/*  readOnly*/}
        {/*/>*/}
      </FunctionWrap>
      <NewTableContainer
        params={{}}
        getParam={(f) => f}
        // params 값이 없이 사용하는 테이블
        useFetch={false}
        useTotal={false}
        usePagenation={false}
        useToolBar={false}
        rowsPerPage={-1}
        customized={rankCustom}
        loading={rankLoading}
        useCustomTable
        propsList={rankData}
        propsHeadCells={makeHeadData(rankHead)}
      />
      <NewTableContainer
        params={{}}
        getParam={(f) => f}
        // params 값이 없이 사용하는 테이블
        useFetch={false}
        useTotal={false}
        usePagenation={false}
        useToolBar={false}
        rowsPerPage={-1}
        customized={customized.request}
        loading={requestLoading}
        useCustomTable
        propsList={requestData}
        propsHeadCells={makeHeadData(requestHead)}
      />
      <NewTableContainer
        params={params}
        getParam={getParam}
        useFetch={false}
        useTotal={false}
        useExcel={false}
        useFullScreen={false}
        rowsPerPage={50}
        customized={customized.list}
        loading={cardLoading}
        useCustomTable
        propsList={cardData}
        propsHeadCells={makeHeadData(cardHead)}
      />
      {modal['open'] && (
        <ScriptModal
          modal={modal}
          handleClose={handleModalClose}
          handleSubmit={handleSubmit}
          pageType={pageType}
          userList={userList}
          duplicate={duplicate}
          solution={solution}
          error={error}
          getParams={modalGetParam}
          getModalParam={getModalParam}
          loading={modalLoading}
        />
      )}
    </>
  );
};

export default withRouter(RequestList);
